import { Fragment, useState } from "react";
import Store from "../components/Store/Store";
import Header from "../components/Header&Footer/Header";
import StoreFilter from "../components/Store/StoreFilter";

const Stores = (props) => {
  const [cartIsShown, setCartIsShown] = useState(false);

  const showCartHandler = () => {
    setCartIsShown(true);
  };

  const hideCartHandler = () => {
    setCartIsShown(false);
  };
  return (
    <Fragment>
      <Header showCart={showCartHandler} />
      <StoreFilter />
      <Store />
      <ul>{cartIsShown && 12}</ul>
    </Fragment>
  );
};

export default Stores;
